import Cookies from 'js-cookie';
import { isSyntheticTest } from 'src/utils/validators/isSyntheticTest';
import { COOKIES_LOOKUP } from '../auth/constants';
import { initDatadog } from './utils/initDatadog';

const _datadog = initDatadog();
const { addAction, addError, ...rest } = _datadog;
const wrapContext = <T extends object | undefined>(context: T) => ({
    zhlMortgageApplicationCenterWeb: {
        zguid: Cookies.get(COOKIES_LOOKUP.SESSION_GUID),
        ...context,
    },
});
const wrappedAddAction = (...args: Parameters<typeof addAction>): ReturnType<typeof addAction> => {
    // intentionally not logged actions for synthetic tests because of a conversation we had where
    // synthetic tests were polluting our data and masking real users
    if (isSyntheticTest()) {
        return;
    }
    const [action, unwrappedContext] = args;
    addAction(action, wrapContext(unwrappedContext));
};
const wrappedAddError = (...args: Parameters<typeof addError>): ReturnType<typeof addError> => {
    const [error, unwrappedContext] = args;
    addError(error, wrapContext(unwrappedContext));
};

/**
 * A shimmed version of the datadog client that excludes synthetic tests from resulting in logged telemetry
 */
export const datadog: typeof _datadog = {
    ...rest,
    addAction: wrappedAddAction,
    addError: wrappedAddError,
};
